export type Plan = {
  id: number;
  title: string;
  features: string[];
  description: string;
  description_heading: string;
  prices: PlanPrice[];
  icon: any;
};

export type PlanPrice = {
  id: number;
  subscription_plan_id: number;
  price_id: string;
  title: string;
  value: string;
  discount: string | null;
  description: string;
};

export enum PlanSlugs {
  plus = "psiapp-mais-pro",
  basic = "psiapp-membro-pro",
  free = "free-admin-premium",
}
